export const footerData = [
  // {
  //   title: "Top AI Tools",
  //   items: [
  //     { label: "ChatGPT", link: "/tools/chatgpt" },
  //     { label: "Midjourney", link: "/tools/midjourney" },
  //   ],
  // },
  // {
  //   title: "More Tools",
  //   items: [
  //     { label: "Runway", link: "/tools/runway" },
  //     { label: "Copy.ai", link: "/tools/copy-ai" },
  //   ],
  // },
  // {
  //   title: "Recommend",
  //   items: [
  //     { label: "Best for Content", link: "/recommend/content" },
  //   ],
  // },
  {
    title: "Read More",
    items: [
      // { label: "Blogs", link: "/blog" },
      // { label: "Tutorials", link: "/tutorials" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "About", link: "/about" },
      { label: "Contact Us", link: "/contact" },
      { label: "Blog", link: "/blog" },
    ],
  },
];
